import { EntitiesHelper } from "../helpers/entities.helper";
import { EnumTipoSelecao } from "../enums/EnumTipoSelecao";
import { BaseObj } from "./UserdataSync";

export class Grifo extends BaseObj {
  id: string;
  idConjunto: string;
  idLei: string;
  idItem: string;
  idImportacao: number;
  inicio: number;
  termino: number;
  tipo: EnumTipoSelecao;
  marcacaoDesatualizada: boolean;

  constructor() {
    super();

    this.id = EntitiesHelper.generateGuid();
  }
}

export class MarcacaoGrifaTexto extends BaseObj {
  usuarioId: string;
  idLei: string;
  marcacacoesGrifaTextoItens: Grifo[];
}
